<div id="wait_mask" class="" *ngIf="showLoading">
    <div [ngSwitch]="switchGIF">
        <!-- 當 power 不是 5 或 16 時 -->
        <div *ngSwitchDefault [ngClass]="{'message': defaultLoadingType === 1, 'message2': defaultLoadingType === 2}">
            <!-- Happy Dance Loading -->
            <img *ngIf="defaultLoadingType === 1"
                src="assets/dist/img/loading-spinner.svg"
                alt="Loading..." />
            <!-- Icon Loading -->
            <img *ngIf="defaultLoadingType === 2" 
                src="assets/dist/img/icon loading GIF.gif" 
                alt="Loading..." />
            <button *ngIf="canSwitchGIF()" 
                    class="switch-btn" 
                    (click)="switchDefaultLoading()">🐸</button>
        </div>

        <!-- 當 power 是 5 或 16 時 -->
        <div *ngSwitchCase="5" class="message2">
            <img src="assets/dist/img/icon loading GIF.gif" alt="Loading..." />
        </div>
        <div *ngSwitchCase="16" class="messageNormal">
            loading...
        </div>
    </div>
</div>